module.exports = __webpack_public_path__ + "img/yyxz.39ccf28d.png";